import React from 'react';

export default function StatusPlacement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Status Placement</h1>
      <p className="text-gray-500">Halaman Status Placement</p>
    </div>
  );
}
